var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeviasCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3832 4.00079C21.2035 3.17071 21.2035 1.82266 20.3832 0.992584C19.5629 0.162506 18.2307 0.162506 17.4104 0.992584L10.5 7.9918L3.58316 0.999225C2.76285 0.169147 1.43066 0.169147 0.610352 0.999225C-0.209961 1.8293 -0.209961 3.17735 0.610352 4.00743L7.52723 11L0.616914 17.9992C-0.203398 18.8293 -0.203398 20.1774 0.616914 21.0074C1.43723 21.8375 2.76941 21.8375 3.58973 21.0074L10.5 14.0082L17.4169 21.0008C18.2372 21.8309 19.5694 21.8309 20.3897 21.0008C21.21 20.1707 21.21 18.8227 20.3897 17.9926L13.4729 11L20.3832 4.00079Z",
    fill: "#44A59E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeviasCancel);
export default __webpack_public_path__ + "static/media/levias-cancel.49338d44f873c36ea59f76c2c9e17cbc.svg";
export { ForwardRef as ReactComponent };